export default {
  form: {
    address: {
      label: 'Adresse',
      placeholder: 'Adresse',
    },
    zip_code: {
      label: 'Code postal',
      placeholder: 'Code postal',
    },
    city: {
      label: 'Ville',
      placeholder: 'Ville',
    },
    start_time: {
      label: 'Heure de début',
      placeholder: 'ex. 11:00',
    },
    name: {
      label: 'Nom du lieu (facultatif)',
      placeholder: 'ex. À côté de la Fernsehturm',
      tooltip: "Saisir un nom de lieu peut aider les clients à identifier l'endroit, ex. « À côté de la Fernsehturm »",
    },
    note: {
      label: 'Note',
      placeholder: 'Saisir une note',
    },
  },
  buttons: {
    add_location: 'Ajouter un lieu',
  },
};
